module.exports = __webpack_public_path__ + "static/media/club-credito-caprabo.5ebfb3e3.png";